import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-add-logo-size-image',
  templateUrl: './add-logo-size-image.component.html',
  styleUrls: ['./add-logo-size-image.component.css']
})
export class AddLogoSizeImageComponent implements OnInit {
  @Input() public  popupType: any;
  @Input() public  memberObj: any;
  @Output() public  closeThePopup = new EventEmitter<any>();
  @Output() public  outputImage = new EventEmitter<any>();
  name = "Angular";
  currentStep: number = 1;
  imageChangedEvent: any = "";
  croppedImage: any = "";
  public multipleWebcamsAvailable = false;
  public allowCameraSwitch = true;
  public showWebcam = true;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
      // width: {ideal: 1024},
      // height: {ideal: 576}
  };
  public errors: WebcamInitError[] = [];
  index: number = 0;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<
      boolean | string
  >();

  // latest snapshot
  public webcamImage: WebcamImage = null;

  constructor() { }

  ngOnInit(): void {
  }

  triggerSnapshot(): void {
    this.index = 1;
    this.trigger.next();
    this.currentStep++;
}

get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
}

get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
}

cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
}

handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
}

handleImage(webcamImage: WebcamImage): void {
    // this.pictureTaken.emit(webcamImage);
    this.webcamImage = webcamImage;
}

fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.currentStep++;
}
imageCropped(event: any) {
    this.croppedImage = event.base64;
}

closePopup() {
    this.closeThePopup.emit("");
}

resetAll() {
    this.currentStep = 1;
    this.imageChangedEvent = "";
    this.croppedImage = "";
}

next() {
    this.currentStep++;
}

finish() {
    this.outputImage.emit(this.croppedImage);
}

}
